/**
 * Extract check number from MICR scan data.
 * Personal: digits after the last '+' (e.g. @083904181@5257387+1011 → 1011).
 * Business (* present): digits between start and first '+'.
 */
export function extractCheckNumberFromMicr(micrData: string | null | undefined): string {
	if (!micrData?.trim()) return '';

	const micr = micrData.trim().replace(/\0/g, '');
	const isBusinessCheck = micr.includes('*');

	if (isBusinessCheck) {
		const endAux = micr.indexOf('+', 1);
		if (endAux > 1) {
			return micr.substring(micr.startsWith('*') ? 1 : 0, endAux).replace(/[^0-9]/g, '');
		}
		return '';
	}

	const lastPlus = micr.lastIndexOf('+');
	if (lastPlus < 0) return '';

	return micr
		.substring(lastPlus + 1)
		.replace(/[@+]/g, '')
		.replace(/[^0-9]/g, '')
		.trim();
}
